import * as actions from './ecommerce.actions';
import { ActionType as AT } from './enums/action-type.enum';
import { EcommerceProduct } from '../../models/ecommerce-product.interface';

type InferValueTypes<T> = T extends { [key: string]: infer U } ? U : never;
type Action = ReturnType<InferValueTypes<typeof actions>>;

class EcommerceState {
  cart: EcommerceProduct[] = [];
  viewed: EcommerceProduct[] = [];
}

export const ecommerceReducer = (state:EcommerceState= new EcommerceState(), action:Action):EcommerceState => {
  switch (action.type) {
    case AT.REVIEW_PRODUCT: {
      return { ...state, viewed: [...state.viewed, action.payload.product] }
    }

    case AT.ADD_PRODUCT_TO_CART: {
      return { ...state, cart: [...state.cart, action.payload.product] }
    }

    case AT.REMOVE_PRODUCT_FROM_CART: {
      const cart = [...state.cart];
      cart.pop();

      return { ...state, cart };
    }

    case AT.PURCHASE_PRODUCTS: {
      return { ...state, cart: [] };
    }

    default: return state;
  }
}
